import request from '../httpClient';
// tslint:disable
export const fetchAirbnbResources = (
  accountId: number,
  otaListingIds: string[]
) => {
  const data = {
    otaListingIds: otaListingIds
  };
  return request.post(`/integration/airbnb/${accountId}/resources`, data);
};

export const fetchAirbnbListings = (
  accountId: number,
  otaListingIds: number[],
  refresh = false
) => {
  const data = {
    otaListingIds: otaListingIds
  };
  let url = `/integration/airbnb/${accountId}/listings`;
  if (refresh) url = `${url}?refresh=true`;
  return request.post(url, data);
};



// WEBPACK FOOTER //
// ./src/services/api/integrationApi.ts